import {updateObject} from "../../shared/utils/updateObject";
import * as actionTypes from "./actionTypes";
import {
    initialApnSimsFilterData,
    initialApnSimTable,
    initialApnTablesState,
    initialContractDetailsState,
    initialContractTablesDataState,
    initialCurrentOfferState,
    initialDeviceDetailsConsegnatiState,
    initialDeviceDetailsConsegneState,
    initialFilterSimCollaboratorsState,
    initialListWithLoadingAndErrorState,
    initialListWithLoadingAndErrorStateAndTotalElements,
    initialServiceDetailsState,
    initialServiceListsState, initialSimsAssociatedToPlanFilterData
} from "./helper";

const initialState = {
    cardData: initialListWithLoadingAndErrorState,
    contractDetails: initialContractDetailsState,
    contractTablesData: initialContractTablesDataState,
    deviceTableData: initialListWithLoadingAndErrorState,
    deviceDetails: initialDeviceDetailsConsegneState,
    simsAssociatedToPlan: initialListWithLoadingAndErrorStateAndTotalElements,
    simsAssociatedToPlanFilterData: initialSimsAssociatedToPlanFilterData,
    simsNotAssociatedToOption: initialListWithLoadingAndErrorStateAndTotalElements,
    simsNotAssociatedToOptionFilterData: initialSimsAssociatedToPlanFilterData,
    suitableSimList: initialListWithLoadingAndErrorState,
    currentOffer: initialCurrentOfferState,
    serviceLists: initialServiceListsState,
    apnLists: initialApnTablesState,
    serviceDetails: initialServiceDetailsState,
    simFilterCollaborators: initialFilterSimCollaboratorsState,
    apnSimTable: initialApnSimTable,
    apnSimFilterData: initialApnSimsFilterData,
    deviceDetailsConsegnati: initialDeviceDetailsConsegnatiState
}

const setCardDataAndLoading = (state, action) => {
    return updateObject(state, {
        cardData: updateObject(state.cardData,
            {[action.key]: action.value})
    })
}

const setContractDetailsDataAndLoading = (state, action) => {
    return updateObject(state, {
        contractDetails: updateObject(state.contractDetails,
            {[action.key]: action.value})
    })
}

const setContractTablesDataAndLoading = (state, action) => {
    return updateObject(state, {
        contractTablesData: updateObject(state.contractTablesData,
            {[action.key]: action.value})
    })
}

const setSimsAssociatedToPlanDataAndLoading = (state, action) => {
    return updateObject(state, {
        simsAssociatedToPlan: updateObject(state.simsAssociatedToPlan,
            {[action.key]: action.value})
    })
}

const setSimsAssociatedToOptionAndLoading = (state, action) => {
    return updateObject(state, {
        simsAssociatedToPlan: updateObject(state.simsAssociatedToPlan,
            {[action.key]: action.value})
    })
}

const setSimsAssociatedToPlanFilterDataAndLoading = (state, action) => {
    return updateObject(state, {
        simsAssociatedToPlanFilterData: updateObject(state.simsAssociatedToPlanFilterData,
            {[action.key]: action.value})
    })
}

const setSimsNotAssociatedToOptionFilterData = (state, action) => {
    return updateObject(state, {
        simsNotAssociatedToOptionFilterData: updateObject(state.simsNotAssociatedToOptionFilterData,
            {[action.key]: action.value})
    })
}

const setSimsNotAssociatedToOptionAndLoading = (state, action) => {
    return updateObject(state, {
        simsNotAssociatedToOption: updateObject(state.simsNotAssociatedToOption,
            {[action.key]: action.value})
    })
}

const setDeviceTablesDataAndLoading = (state, action) => {
    return updateObject(state, {
        deviceTableData: updateObject(state.deviceTableData,
            {[action.key]: action.value})
    })
}

const setDeviceDetialsDataAndLoading = (state, action) => {
    return updateObject(state, {
        deviceDetails: updateObject(state.deviceDetails,
            {[action.key]: action.value})
    })
}

const setSuitableSimList = (state, action) => {
    return updateObject(state, {
        suitableSimList: updateObject(state.suitableSimList,
            {[action.key]: action.value})
    })
}

const setCurrentOffer = (state, action) => {
    return updateObject(state, {
        currentOffer: updateObject(state.currentOffer,
            {[action.key]: action.payload})
    })
}

const setServizioTablesDataAndLoading = (state, action) => {
    return updateObject(state, {
        serviceLists: updateObject(state.serviceLists,
            {[action.key]: action.value})
    })
}

const setApnTablesDataAndLoading = (state, action) => {
    return updateObject(state, {
        apnLists: updateObject(state.apnLists,
            {[action.key]: action.value})
    })
}

const setServizioDetailsDataAndLoading = (state, action) => {
    return updateObject(state, {
        serviceDetails: updateObject(state.serviceDetails,
            {[action.key]: action.value})
    })
}

const setSimFilterCollaborators = (state, action) => {
    return updateObject(state, {
        simFilterCollaborators: updateObject(state.simFilterCollaborators,
            {[action.key]: action.value})
    })
}

const setApnSimTable = (state, action) => {
    return updateObject(state, {
        apnSimTable: updateObject(state.apnSimTable,
            {[action.key]: action.value})
    })
}

const setApnSimsFilterData = (state, action) => {
    return updateObject(state, {
        apnSimFilterData: updateObject(state.apnSimFilterData,
            {[action.key]: action.value})
    })
}

const setDeviceDetialsConsegnatiDataAndLoading = (state, action) => {
    return updateObject(state, {
        deviceDetailsConsegnati: updateObject(state.deviceDetailsConsegnati,
            {[action.key]: action.value})
    })
}

const contrattoDigitaleReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_CONTRACT_CARD_DATA_OR_LOADING:
            return setCardDataAndLoading(state, action);
        case actionTypes.GET_CONTRACT_DETAILS_DATA_OR_LOADING:
            return setContractDetailsDataAndLoading(state, action);
        case actionTypes.GET_CONTRACT_TABLES_DATA_OR_LOADING:
            return setContractTablesDataAndLoading(state, action);
        case actionTypes.GET_SIMS_ASSOCIATED_TO_PLAN_DATA_OR_LOADING:
            return setSimsAssociatedToPlanDataAndLoading(state, action)
        case actionTypes.GET_SIMS_ASSOCIATED_TO_PLAN_OR_OPTION_FILTER_DATA:
            return setSimsAssociatedToPlanFilterDataAndLoading(state, action)
        case actionTypes.GET_SIMS_NOT_ASSOCIATED_TO_OPTION_FILTER_DATA:
            return setSimsNotAssociatedToOptionFilterData(state, action)
        case actionTypes.GET_SIMS_ASSOCIATED_TO_OPTION_OR_LOADING:
            return setSimsAssociatedToOptionAndLoading(state, action)
        case actionTypes.GET_SIMS_NOT_ASSOCIATED_TO_OPTION_OR_LOADING:
            return setSimsNotAssociatedToOptionAndLoading(state, action)
        case actionTypes.GET_DEVICE_TABLES_DATA_OR_LOADING:
            return setDeviceTablesDataAndLoading(state, action);
        case actionTypes.GET_DEVICE_DETAILS_CONSEGNE_DATA_OR_LOADING:
            return setDeviceDetialsDataAndLoading(state, action);
        case actionTypes.GET_SUITABLE_SIM_LIST:
            return setSuitableSimList(state, action);
        case actionTypes.GET_DC_FETCH_CURRENT_OFFER:
            return setCurrentOffer(state, action)
        case actionTypes.GET_SERVICE_DATA_OR_LOADING:
            return setServizioTablesDataAndLoading(state, action)
        case actionTypes.GET_SERVICE_DETAILS_OR_LOADING:
            return setServizioDetailsDataAndLoading(state, action)
        case actionTypes.GET_SIM_FILTER_COLLABORATORS:
            return setSimFilterCollaborators(state, action)
        case actionTypes.GET_APN_TABLES_DATA_AND_LOADING:
            return setApnTablesDataAndLoading(state, action)
        case actionTypes.GET_APN_SIMS_TABLE_AND_LOADING:
            return setApnSimTable(state, action)
        case actionTypes.GET_APN_SIMS_FILTER_DATA_AND_LOADING:
            return setApnSimsFilterData(state, action)
        case actionTypes.GET_DEVICE_DETAILS_CONSEGNATI_DATA_OR_LOADING:
            return setDeviceDetialsConsegnatiDataAndLoading(state, action)
        default:
            return state;
    }
}

export default contrattoDigitaleReducer;
